<mat-dialog-actions cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
	<div class="title"  >
		{{ 'MODALS.HEADERS.TASK'| translate }}
		<app-component-loading [size]="'inline'" [margin]="'0px'" *ngIf="this.formState === 'Submitting'"></app-component-loading>
	</div>
	<mat-icon svgIcon="close-line" mat-dialog-close style="width: 20px;"></mat-icon>
</mat-dialog-actions>
<fieldset [disabled]="formState ==='Submitting'">
	<form [formGroup]="mngtTaskForm" class="task-form">
        <mat-form-field class="form-field-cs"  [hideRequiredMarker]="true" style="width: 100% !important;">
            <mat-label>{{ 'MODALS.FIELDS.TITLE' | translate }}</mat-label>
            <input matInput formControlName="title" autocomplete="disabled" >
            @if (title.hasError('required')) {
                <mat-error>{{'VALIDATION.REQUIRED' | translate}}</mat-error>
            }
        </mat-form-field>

        <mat-select 
                class="task-form-select body-l-regular text-extra select-rotate" 
                disableRipple panelClass="nd-select-board" 	
                [placeholder]="'MODALS.FIELDS.SELECT.BUSINESS_PROCESS' | translate " formControlName="boardData">
            <mat-select-trigger>
                {{('MODALS.FIELDS.BUSINESS_PROCESS'|translate) +':  '}}{{ boardData.value?.name }} 
            </mat-select-trigger>
            @for (board of  this.boards;  track board.id) {
                <mat-option (click)="task_type.patchValue(board?.task_types[0])"
                lass="body-l-regular text-extra task-form-select-option " [value]="board"> <div>{{board.alias +' - '+ board?.name }}</div> </mat-option>
            }
        </mat-select>
        <mat-select *ngIf="task_type?.value"
                class="task-form-select body-l-regular text-extra select-rotate" 
                disableRipple panelClass="nd-select-board" 	
                [placeholder]="'MODALS.FIELDS.TASK_TYPE' | translate " formControlName="task_type">
            <mat-select-trigger>
                {{('MODALS.FIELDS.TASK_TYPE'|translate) +':  '}}{{ task_type?.value.name }} 
            </mat-select-trigger>
            @for (tasktype of  this.boardData?.value?.task_types;  track tasktype.id) {
                <mat-option  class="body-l-regular text-extra task-form-select-option " [value]="tasktype"> <div>{{tasktype?.name }}</div> </mat-option>
            }
        </mat-select>
<!--         @if (board_alias.hasError('required')) {
                <mat-error>{{'VALIDATION.REQUIRED' | translate}}</mat-error>
        } -->

<!--         <mat-form-field class="form-field-cs"  [hideRequiredMarker]="true" style="width: 100% !important; height: unset !important;">
            <mat-label>{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</mat-label>
            <textarea matInput formControlName="content" autocomplete="disabled" rows="3" >
            </textarea>
        </mat-form-field> -->
        <mat-label style="margin-left: 4px;">{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</mat-label>
        <app-component-ckeditor
            (emitFinish)="content.patchValue($event[1])"
            [isShowButtons]="false"
            [isShowEditor]="false">
        </app-component-ckeditor>


        <div class="task-form-button-block">
            <button mat-dialog-close class="button-icon size-xl secondary-button"  [disabled]="this.formState === 'Submitting'">
                <mat-icon svgIcon="close-line"></mat-icon>
                {{ 'MODALS.BUTTONS.CANCEL'|translate }}
            </button>
            <button (click)="createTask()"  data-action="createTask" 
                [disabled]="mngtTaskForm.valid !==true || this.formState === 'Submitting'"
                class="button-icon size-xl primary-button" >
                <mat-icon svgIcon="save-2-fill"></mat-icon>
                {{('MODALS.BUTTONS.SAVE'|translate) }}
            </button>
        </div>
	</form>
</fieldset>